const avatarTabsEquip = {
  photo: 'PHOTO'
};

export default avatarTabsEquip;
